module.exports = __webpack_public_path__ + "static/media/deleted.78d63cf2.gif";